import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core'
import { Location } from '@angular/common'
import { EntityConfiguration } from '../../models/entity-configuration'
import { StoredEntityStateService } from '../../../entity-store-access/services/stored-entity-state.service'
import { ActionService } from '../../../action-module/services/action.service'
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog'
import { EMPTY, Observable, Subject, Subscription } from 'rxjs'
import { EntityDialogComponent } from '../entity-dialog/entity-dialog.component'
import { TableUtils } from '../dynamic-table/table-utils'
import { catchError, map, switchMap, take, tap } from 'rxjs/operators'
import { EntityConfigService, Field } from '../..'
import { StoredEntityService } from '../../../entity-store-access'
import { NotificationService } from '@dot-it/jml-lib'
import { ConfirmationService } from 'primeng/api'

@Component({
  selector: 'jml-lib-dto-actions',
  templateUrl: './dto-actions.component.html',
  styleUrls: ['./dto-actions.component.scss']
})
export class DtoActionsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() dtoType: string
  @Input() orientation: string

  private dialogRef: DynamicDialogRef
  private subscriptions: Subscription[] = []

  globalActions$: Observable<any[]>

  constructor(
    private actionService: ActionService,
    private notificationService: NotificationService,
    private entityConfigService: EntityConfigService,
    private confirmationService: ConfirmationService,
    private location: Location,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!!this.dtoType) {
      this.globalActions$ = this.entityConfigService
        .getConfig$(this.dtoType)
        .pipe(map((config) => config?.globalActions))
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe())
    this.dialogRef?.close()
  }

  performAction(actionHrid: string, actionButton) {
    actionButton.inProgress = true
    this.actionService.performAction(actionHrid, undefined, undefined, (success) => {
      if (success) {
        // TODO - refresh dynamic table??
      }
      actionButton.inProgress = false
    })
  }
}
